import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Banner from './Components/Home/Banner';
import Header from './Components/Header';
import Navbar from './Components/Navbar';
import Footer from "./Components/Footer";
import Home from "./Components/Home";
import Slider from "./Components/Slider"
import About from './Components/About';
import Services from './Components/Services';
import Contact from './Components/Contact';
import FacilitiesCard from "./Components/FacilitiesCard";
import UserTable from "./Components/UsersTable";


const slides = [
  { image: 'https://ibb.co/K9BSg2r' },
  { image: 'https://ibb.co/9hZPdNC' },
  { image: 'https://ibb.co/5rcpJYH' },
  { image: 'https://ibb.co/MsftJTb' },
  { image: 'https://ibb.co/LvThRV2' },
  { image: 'https://ibb.co/3T6GxLx' },
];


function App() {
  return (
    <div className="App">
      
      <Navbar />
      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/about" element={<About/>} />
        <Route path="/user" element={<UserTable/>} />
        <Route path="/contact" element={<Contact/>} />
      </Routes>
      
       
     
      {/* <Header/> */}
      {/* <Banner/> */}
      <Footer/>
    </div>
  );
}

export default App;
